(function () {
  "use strict";

  // hide scent variant on all products (used for candles during holiday promo)
  const labels = Array.from(document.getElementsByClassName("variant__label"))
  const scent = labels.filter((label) => { return label.outerText == 'SCENT' })
  scent[0].parentElement.style.display = "none"
  

})()

